import { render, staticRenderFns } from "./PlateStockPopularTable.vue?vue&type=template&id=0767949b&scoped=true"
import script from "./PlateStockPopularTable.vue?vue&type=script&lang=js"
export * from "./PlateStockPopularTable.vue?vue&type=script&lang=js"
import style0 from "./PlateStockPopularTable.vue?vue&type=style&index=0&id=0767949b&prod&scoped=true&lang=css"
import style1 from "./PlateStockPopularTable.vue?vue&type=style&index=1&id=0767949b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0767949b",
  null
  
)

export default component.exports